package views.representante

import AppStylesheet.attr
import AppStylesheet.style
import androidx.compose.runtime.*
import ffInput
import getRelatorio
import kotlinx.browser.document
import kotlinx.dom.clear
import lbTitulo
import org.jetbrains.compose.web.attributes.onSubmit
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.HTMLDivElement
import utils.ff
import utils.ffDdb
import utils.ffDsd
import utils.ffZeroLeft
import kotlin.js.Date

class rep003 {
    fun show() {

        lbTitulo!!.innerText = "003 - Cortes do faturamento"

        val htmlDiv1 = document.getElementById("htmlDiv1") as HTMLDivElement
        htmlDiv1.clear()

        renderComposable(rootElementId = "htmlDiv1") {
            body()
            //if (lemp5 != null && lemp5!!.count() > 0)
            //body1(lemp5!!)
        }
    }

    @Composable
    fun body() {
        Div(attrs = { classes("dlg-pad-top-5") }) {

            val _periodo1 = remember { mutableStateOf("") }
            val _periodo2 = remember { mutableStateOf(String()) }

            Div {
                Form(attrs = {
                    onSubmit { false }
                    style {
                        property("font-size", "small")
                    }
                }) {
                    Span(attrs = { style { fontWeight("bold") } }) { Text("Informações do relatório") }
                    Hr(attrs = { classes("dlg-hr") })
                    //Span { Text("Período da emissão") }
                    //Br()
                    Div({ classes("form-group", "input-group-append") }) {
                        Div(attrs = { classes("form-group", "input-group-append") }) {
                            ffInput("Período de emissão", _periodo1, "D4", 10, 60)
                            ffInput("", _periodo2, "D4", 10, 60)
                        }
                    }
                }
                Div(attrs = { classes() }) { }

            }

            Div(attrs = { classes("form-group") }) {
                Button(attrs = {
                    classes("btn", "dlg-mobbt100"); onClick { _ ->
                    getRelatorio(
                        14,
                        "|sDtIni${_periodo1.value.ffDsd().ffDdb()}|sDtFim${_periodo2.value.ffDsd().ffDdb()}"
                    )
                }
                }
                ) {
                    Text("Visualizar")
                }
            }

        }

    }
}